import { FloatingDelayGroup } from '@floating-ui/react'
import type { PropsWithChildren, ReactNode } from 'react'

export const TOOLTIP_OPEN_DELAY = 250
const TOOLTIP_WARM_WINDOW = 300

export const TooltipProvider = ({ children }: PropsWithChildren): ReactNode => (
  <FloatingDelayGroup
    delay={{ open: TOOLTIP_OPEN_DELAY, close: 0 }}
    timeoutMs={TOOLTIP_WARM_WINDOW}
  >
    {children}
  </FloatingDelayGroup>
)
